import prettyBytes from 'pretty-bytes';

export const convertBytes = value => value && prettyBytes(value);
